import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "@/hooks/useAppSelector";

import SettingTitle from "../component/SettingTitle";
import { Navigate } from "react-router-dom";
import CustomToast from "@/components/UI/CustomToast/CustomToast";
import { useEffect, useState } from "react";
import theme from "@/theme";
import DeactivateYourAccountModal from "../component/DeactivateYourAccountModal";

const DeactivateYourAccount = () => {
  const location = useLocation();
  const [isDeactivateOpen, setIsDeactivateOpen] = useState(false);
  const [toast, setToast] = useState<{ message: string; success: boolean } | null>(null);
  const { user: authUser } = useAppSelector((state) => state.auth);
  if (!authUser) return <Navigate to="/" replace />;

  useEffect(() => {
    if (location.state?.message) {
      setToast({
        message: location.state.message,
        success: location.state.success ?? true,
      });

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <>
      {toast && (
        <CustomToast
          message={toast.message}
          success={toast.success}
          onClose={() => setToast(null)}
        />
      )}
      <SettingTitle title="Deactivate your account" back isActive={true} />
      <Box
        sx={{
          display: "flex",
          flexDiraction: "column",
          padding: "12px 16px",
          borderBottom: "1px solid #f5f5f5",
          gap: "10px",
        }}
        flexDirection={"column"}
      >
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: 0,
            color: theme.palette.custom.blueGray900,
          }}
        >
          This will deactivate your account
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: 0,
            color: theme.palette.custom.blueGray600,
          }}
        >
          You’re about to start the process of deactivating your Wethemrkt account. Your display
          name, @username, and public profile will no longer be viewable on Wethemrkt.com, Wethemrkt
          for iOS, or Wethemrkt for Android.
        </Typography>
      </Box>
      <Box
        sx={{
          mt: "16px",
          display: "flex",
          flexDiraction: "column",
          padding: "12px 16px",
          gap: "10px",
        }}
        flexDirection={"column"}
      >
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: 0,
            color: theme.palette.custom.blueGray600,
          }}
        >
          You can restore your Wethemrkt account if it was accidentally or wrongfully deactivated
          for up to 30 days after deactivation.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: 0,
            color: theme.palette.custom.blueGray600,
          }}
        >
          If you just want to change your @username, you don’t need to deactivate your account —
          edit it in your settings.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: 0,
            color: theme.palette.custom.blueGray600,
          }}
        >
          To use your current @username or email address with a different Wethemrkt account, change
          them before you deactivate this account.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: "16px",
          mb: "40px",
        }}
      >
        <Typography
          onClick={() => setIsDeactivateOpen(true)}
          sx={{
            width: "544px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.error.main,
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          Deactivate
        </Typography>
      </Box>
      <DeactivateYourAccountModal
        open={isDeactivateOpen}
        onClose={() => setIsDeactivateOpen(false)}
        onConfirm={() => {
          setIsDeactivateOpen(false);
        }}
      />
    </>
  );
};

export default DeactivateYourAccount;
